import { render, staticRenderFns } from "./technical-error.vue?vue&type=template&id=3d3c40b0&lang=pug"
import script from "./technical-error.vue?vue&type=script&lang=js"
export * from "./technical-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports